import React, { useState, useEffect } from 'react';
import BookingHeader from '../components/BookingInfo/BookingHeader';
import Qualifications from '../components/BookingInfo/Qualifications';
import { useAuth0 } from '@auth0/auth0-react';
import { Route, useParams, useHistory, useRouteMatch } from 'react-router-dom';
import {
    Typography,
    Grid,
    Card,
    Box,
    ToggleButtonGroup,
    ToggleButton,
    Skeleton,
} from '@mui/material';
import Documents from '../components/BookingInfo/Documents';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

const ViewSchoolJobApplication = props => {
    const { getAccessTokenSilently } = useAuth0();
    let { jobId, teacherId } = useParams();
    let history = useHistory();

    const [selectedJob, setSelectedJob] = useState([]);
    const [updateStatus, setUpdateStatus] = useState(false);
    const [formats, setFormats] = React.useState(() => ['NotAssessed']);

    let match = useRouteMatch();
    useEffect(() => {
        if (props.jobSubmissions.Count !== 0) {
            const sJob = props.jobSubmissions.Data.filter(
                job =>
                    job.user.uniqueId === teacherId &&
                    job.submission['gs1-pk'] === jobId
            );
            setSelectedJob(sJob);
            console.log('Selected Job', selectedJob);
            if (sJob.length > 0 && sJob[0].submission.status) {
                setFormats([sJob[0].submission.status]);
            }
        }
    }, [props]);

    const handleFormat = async (event, newFormats) => {
        try {
            setUpdateStatus(true);
            async function changeSubmissionsState() {
                const token = await getAccessTokenSilently();
                const data = {
                    status: newFormats,
                    submission: selectedJob[0].submission['gs1-pk'],
                    teacher: selectedJob[0].user.pk1,
                    sk1: selectedJob[0].submission.sk1,
                };
                const changeStatus = await axios.put(
                    `${process.env.REACT_APP_API_GATEWAY}/jobSubmissions`,
                    data,
                    {
                        timeout: 30000,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                );
                props.updateSubmissionStatus(
                    newFormats,
                    selectedJob[0].user.uniqueId,
                    selectedJob[0].submission['gs1-pk']
                );
            }
            changeSubmissionsState();
        } catch (err) {
            console.log(err);
        } finally {
            setUpdateStatus(false);
        }

        setFormats(newFormats);
    };

    return (
        <Grid container>
            {selectedJob.length !== 0 && selectedJob[0].user !== undefined ? (
                <Grid
                    item
                    md={8}
                    sx={{
                        margin: 'auto',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        boxShadow: '1px 0px 7px rgba(0, 0, 0, 0.5)',
                    }}
                >
                    <Box sx={{ margin: '12px 24px 0px', textAlign: 'right' }}>
                        {updateStatus ? (
                            <Skeleton />
                        ) : (
                            <ToggleButtonGroup
                                value={formats}
                                onChange={handleFormat}
                                aria-label="text formatting"
                                sx={{ marginRight: '12px' }}
                                exclusive
                            >
                                <ToggleButton
                                    value="NotAssessed"
                                    aria-label="NotAssessed"
                                >
                                    Not Assessed
                                </ToggleButton>
                                <ToggleButton
                                    value="ShortListed"
                                    aria-label="ShortListed"
                                >
                                    Short Listed
                                </ToggleButton>
                                <ToggleButton
                                    value="Rejected"
                                    aria-label="Rejected"
                                >
                                    Rejected
                                </ToggleButton>
                                <ToggleButton
                                    value="Contacted"
                                    aria-label="Contacted"
                                >
                                    Contacted
                                </ToggleButton>
                            </ToggleButtonGroup>
                        )}

                        <CloseIcon
                            onClick={() => {
                                history.push(`/schooljobs`);
                            }}
                            color="primary"
                            fontSize="large"
                            sx={{
                                border: '1px solid #1E7CA8',
                                borderRadius: '50%',
                                padding: '4px',
                            }}
                        />
                    </Box>
                    <BookingHeader
                        booking={{
                            'teacherProfile': selectedJob[0].user.profileImage,
                            'teacherFirstName': selectedJob[0].user.firstName,
                            'teacherLastName': selectedJob[0].user.lastName,
                            'teacherBio': selectedJob[0].user.bio,
                        }}
                        phoneNumber={selectedJob[0].user.phoneNumber}
                        email={selectedJob[0].user.email}
                        teacherRating={selectedJob[0].user.rating}
                        teacherRatingAmount={
                            selectedJob[0].user.amountOfRatings
                        }
                        userType="School"
                        border={false}
                    />

                    <Box sx={{ margin: '12px' }}>
                        {selectedJob[0].submission.data?.coverLetter !==
                            undefined && (
                            <>
                                <Typography
                                    variant="h5"
                                    sx={{ marginTop: '12px' }}
                                >
                                    Cover Letter
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ margin: '12px 0px' }}
                                >
                                    {selectedJob[0].submission.data.coverLetter}
                                </Typography>
                            </>
                        )}
                    </Box>
                    <Documents
                        gs1pk={selectedJob[0].user.pk1}
                        loadOnInit={true}
                        border={false}
                        filterResume={true}
                        jobSk1={selectedJob[0].submission.sk1}
                    ></Documents>
                    <Qualifications
                        skills={selectedJob[0].user.skills}
                        otherSkills={selectedJob[0].user.otherSkills}
                        grades={selectedJob[0].user.grades}
                        gs1pk={selectedJob[0].user['gs1-pk']}
                        border={false}
                    />
                </Grid>
            ) : (
                <>
                    <Typography>Finding Job Details</Typography>
                </>
            )}
        </Grid>
    );
};

export default ViewSchoolJobApplication;
